uniform float uTime;
uniform float uFadeOut;
uniform float uProgress; // 0 = тільки основа, 1 = повний стовпчик
uniform float uSeed;
attribute float aSize;
attribute float aOffset;
attribute vec3  aRandom;

varying float vAlpha;
varying float vLife; // 0 = народилась, 1 = зникла

// ── Simplex Noise 3D (той самий що у flame) ──────────────────
vec3 mod289(vec3 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec4 mod289(vec4 x) { return x - floor(x * (1.0 / 289.0)) * 289.0; }
vec4 permute(vec4 x) { return mod289(((x*34.0)+1.0)*x); }
vec4 taylorInvSqrt(vec4 r) { return 1.79284291400159 - 0.85373472095314 * r; }

float snoise(vec3 v) {
    const vec2 C = vec2(1.0/6.0, 1.0/3.0);
    const vec4 D = vec4(0.0, 0.5, 1.0, 2.0);
    vec3 i  = floor(v + dot(v, C.yyy));
    vec3 x0 = v - i + dot(i, C.xxx);
    vec3 g = step(x0.yzx, x0.xyz);
    vec3 l = 1.0 - g;
    vec3 i1 = min(g.xyz, l.zxy);
    vec3 i2 = max(g.xyz, l.zxy);
    vec3 x1 = x0 - i1 + C.xxx;
    vec3 x2 = x0 - i2 + C.yyy * 2.0;
    vec3 x3 = x0 - D.yyy;
    i = mod289(i);
    vec4 p = permute(permute(permute(
        i.z + vec4(0.0, i1.z, i2.z, 1.0)) +
        i.y + vec4(0.0, i1.y, i2.y, 1.0)) +
        i.x + vec4(0.0, i1.x, i2.x, 1.0));
    float n_ = 0.142857142857;
    vec3 ns = n_ * D.wyz - D.xzx;
    vec4 j  = p - 49.0 * floor(p * ns.z * ns.z);
    vec4 x_ = floor(j * ns.z);
    vec4 y_ = floor(j - 7.0 * x_);
    vec4 x  = x_ * ns.x + ns.y;
    vec4 y  = y_ * ns.x + ns.y;
    vec4 h  = 1.0 - abs(x) - abs(y);
    vec4 b0 = vec4(x.xy, y.xy);
    vec4 b1 = vec4(x.zw, y.zw);
    vec4 s0 = floor(b0)*2.0 + 1.0;
    vec4 s1 = floor(b1)*2.0 + 1.0;
    vec4 sh = -step(h, vec4(0.0));
    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy;
    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww;
    vec3 p0 = vec3(a0.xy, h.x);
    vec3 p1 = vec3(a0.zw, h.y);
    vec3 p2 = vec3(a1.xy, h.z);
    vec3 p3 = vec3(a1.zw, h.w);
    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0),dot(p1,p1),dot(p2,p2),dot(p3,p3)));
    p0 *= norm.x; p1 *= norm.y; p2 *= norm.z; p3 *= norm.w;
    vec4 m = max(0.6 - vec4(dot(x0,x0),dot(x1,x1),dot(x2,x2),dot(x3,x3)), 0.0);
    m = m * m;
    return 42.0 * dot(m*m, vec4(dot(p0,x0),dot(p1,x1),dot(p2,x2),dot(p3,x3)));
}

void main() {
    // t: 0 = виникає на вершині вогника, 1 = розчиняється вгорі
    float t = mod(uTime * 0.14 + aOffset, 1.0);
    vLife = t;

    vec3 pos = position;

    // 1. Піднімається вгору — повільно, тонка струйка
    pos.y += 0.85 + t * 2.6;

    // 2. Плавний вигин — drift квадратичний: знизу майже нуль, вгорі трохи
    //    Використовуємо низькочастотний noise для єдиного плавного вигину
    float curl = t * t * 0.09; // квадратичний — знизу тонко, вгорі трохи ширше
    pos.x += snoise(vec3(0.5, pos.y * 0.6 - uTime * 0.2 + uSeed, 0.5)) * curl;
    pos.z += snoise(vec3(0.5, pos.y * 0.6 + uTime * 0.18 + uSeed + 3.7, 0.5)) * curl * 0.4;

    // 3. Мінімальний конус — струйка майже вертикальна
    pos.x += aRandom.x * t * 0.022;
    pos.z += aRandom.z * t * 0.012;

    // 4. Альфа: м'яке народження → повільне зникнення
    float fadeIn  = smoothstep(0.0, 0.12, t);
    float fadeOut = 1.0 - smoothstep(0.55, 1.0, t);

    // Grow mask: t=0 внизу (вогник), t=1 вгорі
    // Відкриваємо стовпчик знизу вгору — частинки з t > uProgress невидимі
    float growMask = smoothstep(uProgress, uProgress - 0.18, t);

    vAlpha = fadeIn * fadeOut * 0.38 * uFadeOut * growMask;

    vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);

    // Розмір: маленький і майже не росте — зберігаємо ефект нитки
    float sizeScale = 0.28 + t * 0.55;
    gl_PointSize = aSize * sizeScale * (500.0 / -mvPosition.z);
    gl_Position  = projectionMatrix * mvPosition;
}
